<template>
    <div>
        <Breadcrumb section-name="Order" :breadcrumb="breadCrumb"></Breadcrumb>
        <div class="col-12">
            <div class="card mb-0">
                <div class="card-body" :class="{'data-loading': dataLoading}">
                    <form @submit.prevent="saveOrder">
                        <div class="fixed-card-height">
                            <div class="card border-top border-0 border-4 border-primary">
                                <div class="card-body p-4">
                                    <div class="card-title d-flex align-items-center">
                                        <h5 class="mb-0 text-primary">Order</h5>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Date<span class="text-danger">*</span></label>
                                            <flat-pickr class="form-control" v-model="addEditParam.date" name="date"
                                                        :config="{dateFormat: 'Y-m-d', altInput: true, altFormat:'d/m/Y'}"/>
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">ID Number</label>
                                            <input type="text" v-model="addEditParam.id_number" class="form-control" disabled>
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Reference Number</label>
                                            <input type="text" v-model="addEditParam.ref_number" class="form-control" disabled>
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Customer Name</label>
                                            <input type="text" v-model="addEditParam.customer_name" class="form-control">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Customer Address</label>
                                            <input type="text" v-model="addEditParam.customer_address" class="form-control">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Customer Contact Number</label>
                                            <input type="text" v-model="addEditParam.customer_contact_number" class="form-control">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Order Number</label>
                                            <input type="text" v-model="addEditParam.order_number" class="form-control">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Order Date</label>
                                            <flat-pickr class="form-control" v-model="addEditParam.order_date" name="order_date"
                                                        :config="{dateFormat: 'Y-m-d', altInput: true, altFormat:'d/m/Y'}"/>
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Vehicle Type</label>
                                            <input type="text" v-model="addEditParam.vehicle_type" class="form-control">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Driver Name</label>
                                            <input type="text" v-model="addEditParam.driver_name" class="form-control">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Driver Mobile Number</label>
                                            <input type="text" v-model="addEditParam.driver_mobile_number" class="form-control">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Order Quantity</label>
                                            <input type="text" v-model="addEditParam.order_quantity" class="form-control">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Remarks</label>
                                            <input type="text" v-model="addEditParam.remarks" class="form-control">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Description</label>
                                            <input type="text" v-model="addEditParam.description" class="form-control">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Customer Feedback</label>
                                            <input type="text" v-model="addEditParam.customer_feedback" class="form-control">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                    </div>
                                    <table class="table table-bordered">
                                        <thead>
                                        <tr>
                                            <th width="20%">Raw Material</th>
                                            <th width="15%">Unit</th>
                                            <th width="15%">Quantity</th>
                                            <th width="15%">Price</th>
                                            <th width="15%">Total Price</th>
                                            <th width="15%">Description</th>
                                            <th width="5%">Action</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(each,index) in addEditParam.items">
                                            <td>
                                                <div class="form-group">
                                                    <select class="form-control" :name="'items.' + index + '.raw_material_id'" v-model="each.raw_material_id" @change="changeRawMaterial($event, index)">
                                                        <option value="">--Select--</option>
                                                        <option v-for="each in rawMaterials" v-text="each.name" :value="each.id"></option>
                                                    </select>
                                                    <div class="invalid-feedback"></div>
                                                </div>
                                            </td>
                                            <td>
                                                <input type="text" class="form-control" v-model="each.unit_name" disabled>
                                            </td>
                                            <td>
                                                <div class="form-group">
                                                    <input type="text" class="form-control" :name="'items.' + index + '.quantity'" v-model="each.quantity" @input="updateTotalPrice(index)">
                                                    <div class="invalid-feedback"></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-group">
                                                    <input type="text" class="form-control" :name="'items.' + index + '.unit_price'" v-model="each.unit_price" @input="updateTotalPrice(index)">
                                                    <div class="invalid-feedback"></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-group">
                                                    <input type="text" class="form-control" :name="'items.' + index + '.total_price'" v-model="each.total_price" disabled>
                                                    <div class="invalid-feedback"></div>
                                                </div>
                                            </td>
                                            <td>
                                                <input type="text" class="form-control" v-model="each.description">
                                            </td>
                                            <td>
                                                <button type="button" @click="addItem" class="btn btn-primary" v-if="index === 0">+</button>
                                                <button type="button" @click="removeItem(index)" class="btn btn-danger" v-if="index !== 0">x</button>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="text-end">
                            <router-link :to="{name: 'expenseAdd'}" type="button" class="btn btn-secondary me-2 btn-width">Close</router-link>
                            <button type="submit" class="btn btn-primary btn-width" v-if="!loading">
                                Save
                            </button>
                            <button type="button" class="btn btn-primary btn-width" v-if="loading">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Breadcrumb from "../Common/Breadcrumb.vue";
import Table from "../Common/Table.vue";
import ApiService from "../../Services/ApiService";
import ApiRoutes from "../../Services/ApiRoutes";

export default {
    name: "Add",
    components: {Table, Breadcrumb},
    data() {
        return {
            breadCrumb: ['Add'],
            loading: false,
            dataLoading: false,
            addEditParam: {
                date: '',
                id_number: '',
                ref_number: '',
                customer_name: '',
                customer_address: '',
                customer_contact_number: '',
                order_number: '',
                order_date: '',
                vehicle_type: '',
                driver_name: '',
                driver_mobile_number: '',
                order_quantity: '',
                remarks: '',
                description: '',
                customer_feedback: '',
                items: [
                    {raw_material_id: '', unit_name: '', quantity: '', unit_price: '', total_price: '', description: ''}
                ]
            },
            rawMaterials: []
        }
    },
    methods: {
        fetchSingleOrder: function() {
            ApiService.POST(ApiRoutes.Order + '/single', {id: this.$route.params.id}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.addEditParam = res.data;
                }
            });
        },
        saveOrder: function() {
            this.loading = true;
            ApiService.ClearErrorHandler();
            ApiService.POST(ApiRoutes.Order + '/update', this.addEditParam, (res) => {
                this.loading = false;
                if (parseInt(res.status) === 200) {
                    this.$toast.success(res.message);
                    this.$router.push({
                        name: 'order'
                    })
                } else {
                    ApiService.ErrorHandler(res.errors);
                }
            });
        },
        fetchRefNumber: function() {
            ApiService.POST(ApiRoutes.Order + '/get/ref-number', {}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.addEditParam.ref_number = res.data;
                }
            });
        },
        fetchIdNumber: function() {
            ApiService.POST(ApiRoutes.Order + '/get/id-number', {}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.addEditParam.id_number = res.data;
                }
            });
        },
        updateTotalPrice: function(index) {
            this.addEditParam.items[index].total_price = parseFloat(this.addEditParam.items[index].quantity) * parseFloat(this.addEditParam.items[index].unit_price);
        },
        changeRawMaterial: function(event, index) {
            let item = this.rawMaterials.find((v) => v.id === Number(event.target.value));
            this.addEditParam.items[index].unit_name = item.unit_name;
            this.addEditParam.items[index].unit_price = item.price;
        },
        removeItem: function(index) {
            this.addEditParam.items.splice(index, 1)
        },
        addItem: function() {
            this.addEditParam.items.push({
                raw_material_id: '',
                quantity: '',
                unit_price: '',
                total_price: '',
                description: ''
            });
        },
        fetchRawMaterial: function() {
            ApiService.POST(ApiRoutes.RawMaterial + '/list', {limit: 100}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.rawMaterials = res.data.data;
                }
            });
        }
    },
    mounted() {
        this.fetchSingleOrder();
        this.fetchRawMaterial();
        this.fetchIdNumber();
        this.fetchRefNumber();
    }
}
</script>
<style scoped>

</style>
